import { IEvent } from "@Interfaces";
import { isTimePassed } from "@Utils";
import { parseDateTime } from "@Utils/parseDateTime";

export const getWorkshopSlots = (slots?: Array<IEvent.ISlot>) =>
    (slots || [])
        // Only load the slots that have their end time in the future
        .filter(s => !isTimePassed(parseDateTime(s.end_time).valueOf()))
        .map(s => s.uuid);
